import { FunctionComponent, ReactNode } from 'react';

import type { ISingleHistoryGame } from '../../../../../api/fetchers/history/types';
import { L12nText } from '../../../../text/L12nText';

import { MegaSicBacResultMessage } from './megasicbac/MegaSicBacResultMessage';
import { TopCardResultMessage } from './topcard/TopCartResultMessage';

import styles from './ResultsMessage.module.css';

export interface ResultMessageProps {
  game: ISingleHistoryGame;
  type: string;
}

export const ResultMessage: FunctionComponent<ResultMessageProps> = ({ game, type }) => {
  if (!game.cancelled && !game.simulated) return null;
  const isGameCancelled = game.cancelled && !game.simulated;
  const isGameSimulated = game.simulated;
  const gameType = type.toUpperCase();
  return (
    <div className={styles.messageContainer}>
      {isGameCancelled ? (
        <caption className={`${styles.message} ${styles.cancelled}`}>
          <L12nText tk="CANCELLED_PENDING" />
        </caption>
      ) : null}
      {isGameSimulated ? (
        <>
          <caption className={`${styles.message} ${styles.simulated}`}>
            <L12nText tk="RESULT_REVISED" />
          </caption>
          <caption className={`${styles.message} ${styles.simulated}`}>
            {((type: string): ReactNode => {
              switch (type) {
                case 'TOPCARD':
                  return <TopCardResultMessage game={game} />;
                case 'MEGASICBAC':
                  return <MegaSicBacResultMessage game={game} />;
                default:
                  return (
                    <>
                      <L12nText tk="HISTORY_CORRECT_RESULT" />: {game.simulated.newResultCode}
                    </>
                  );
              }
            })(gameType)}
          </caption>
        </>
      ) : null}
    </div>
  );
};
